import { defineSlotRecipe } from '@chakra-ui/react';

// Chakra's default puts a white indicator on a light grey track, so the picked option is hard
// to see. A solid brand indicator on a white, bordered track makes the choice clear at a glance.
export const segmentGroupSlotRecipe = defineSlotRecipe({
  slots: ['root', 'label', 'item', 'itemText', 'itemControl', 'indicator'],
  base: {
    root: {
      '--segment-indicator-bg': 'colors.brand.500',
      '--segment-indicator-shadow': 'none',
      bg: 'neutral.0',
      boxShadow: 'none',
      borderWidth: '1px',
      borderColor: 'neutral.200',
    },
    item: {
      color: 'neutral.300',
      fontWeight: 'medium',
      cursor: 'pointer',
      transition: 'color 0.2s, background-color 0.2s',
      // Hover only the options not picked, so the picked label stays white on the brand fill.
      '&:not([data-state=checked]):hover': { color: 'brand.500', bg: 'brand.50' },
      '&[data-state=checked]': { color: 'neutral.0' },
      '&[data-state=checked][data-ssr]': { bg: 'brand.500', shadow: 'none' },
    },
  },
});
